import { InfoBanner } from "@/components/ui/banner";
import { Button } from "@/components/ui/button";
import { Toggle } from "@/components/ui/form-controls";
import { Field, Input } from "@/components/ui/input";
import { MaintenanceState } from "@/components/ui/system-state";
import { toast } from "@/components/ui/toast";
import { CrossModuleLink, SpecimenCard, SpecimenSection } from "@/features/system-states/system-state-page";

export default function SysMaintenance() {
  return (
    <>
      <SpecimenSection label="Read-only banner">
        <InfoBanner variant="warning" title="Read-only maintenance mode" className="mb-0">
          All records remain available to review. Transfers, approvals and wallet changes are temporarily disabled until
          the window completes.
        </InfoBanner>
      </SpecimenSection>

      <SpecimenSection label="Maintenance window">
        <MaintenanceState
          className="border-line bg-surface"
          title="Scheduled maintenance in progress"
          description="We are performing a planned upgrade to the signing infrastructure. No funds are at risk and no action is required from you."
          endsAt="02:30 UTC (approximately 18 minutes remaining)"
          rows={[
            { k: "Window", v: "09 Sep 2026, 02:00–02:30 UTC" },
            { k: "Duration", v: "30 minutes" },
            { k: "Impact", v: "Mutations disabled · reads available" },
            { k: "Support reference", v: "MW-2026-0909" },
          ]}
          actions={
            <>
              <Button
                variant="secondary"
                onClick={() =>
                  toast({ variant: "info", title: "Subscribed", description: "We will notify you when the window ends." })
                }
              >
                Subscribe to updates
              </Button>
              <CrossModuleLink variant="secondary">View status page</CrossModuleLink>
            </>
          }
        />
      </SpecimenSection>

      <SpecimenSection label="Disabled mutation controls">
        <SpecimenCard label="Controls render in a disabled state with an explanatory tooltip">
          <div className="grid max-w-[640px] gap-4">
            <Field
              label="Transfer amount"
              htmlFor="sys-maint-amount"
              hint="Entries are disabled while maintenance is in progress."
            >
              <Input
                id="sys-maint-amount"
                defaultValue="25,000.00"
                disabled
                title="Available once maintenance completes"
              />
            </Field>
            <div className="flex flex-wrap items-center gap-3">
              <Button disabled title="Available once maintenance completes">
                Initiate transfer
              </Button>
              <Button variant="secondary" disabled title="Available once maintenance completes">
                Save draft
              </Button>
              <Toggle
                checked={false}
                onCheckedChange={() => {}}
                ariaLabel="Enable recurring schedule"
                disabled
              />
              <span className="text-xs text-muted">Recurring schedules</span>
            </div>
          </div>
        </SpecimenCard>
      </SpecimenSection>

      <SpecimenSection label="Behaviour">
        <SpecimenCard label="During the window">
          <ul className="flex list-disc flex-col gap-1.5 pl-5 text-sm text-muted">
            <li>Reads, exports and audit history remain fully available.</li>
            <li>Mutation controls are disabled, never silently queued.</li>
            <li>The read-only banner clears automatically when the window completes.</li>
          </ul>
        </SpecimenCard>
      </SpecimenSection>
    </>
  );
}
